const snippetText = partytownSnippet();
import { partytownSnippet } from "@builder.io/partytown/integration";

const el = document.createElement("script");
el.innerHTML = snippetText;
document.body.appendChild(el);
